export function getTelegramMiniAppUser() {
  const u = window.Telegram?.WebApp?.initDataUnsafe?.user;
  if (!u || typeof u !== "object") return null;
  return {
    first_name: u.first_name || "",
    last_name: u.last_name || "",
    username: u.username || "",
    photo_url: u.photo_url || "",
  };
}
